import {
  NOTIFICATIONS_ALL,
  NOTIFICATIONS_ALL_SUCCESS,
  NOTIFICATIONS_ALL_UNREAD,
  NOTIFICATIONS_ALL_UNREAD_SUCCESS,
  NOTIFICATIONS_GET,
  NOTIFICATIONS_GET_SUCCESS,
  NOTIFICATIONS_LAST,
  NOTIFICATIONS_LAST_SUCCESS,
  NOTIFICATIONS_MARK_READ,
  NOTIFICATIONS_UNREAD,
  NOTIFICATIONS_UNREAD_SUCCESS,
} from '../constants/Notifications';

const initialState = {
  notification: {
    id: null,
    name: '',
    color: '',
  },
  notifications: null,
  perPage: 10,
  page: 1,
  total: null,
  unreadCount: 0,
  unreadNotifications: null,
  lastNotifications: null,
  loading: false,
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATIONS_ALL:
      return {
        ...state,
        loading: true,
      };
    case NOTIFICATIONS_ALL_SUCCESS:
      return {
        ...state,
        notifications: action.notifications,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case NOTIFICATIONS_GET:
      return {
        ...state,
      };
    case NOTIFICATIONS_GET_SUCCESS:
      return {
        ...state,
        notification: action.notification,
      };
    case NOTIFICATIONS_UNREAD:
      return {
        ...state,
      };
    case NOTIFICATIONS_UNREAD_SUCCESS:
      return {
        ...state,
        unreadCount: action.unread,
      };
    case NOTIFICATIONS_ALL_UNREAD:
      return {
        ...state,
      };
    case NOTIFICATIONS_ALL_UNREAD_SUCCESS:
      return {
        ...state,
        unreadNotifications: action.unreadNotifications,
      };
    case NOTIFICATIONS_MARK_READ:
      return {
        ...state,
        notifications: state.notifications
          ? state.notifications.map((n) =>
              n.id === action.notification.id ? { ...n, read: 1 } : n
            )
          : [],
        lastNotifications: state.lastNotifications
          ? state.lastNotifications.filter(
              (n) => n.id !== action.notification.id
            )
          : [],
        unreadNotifications: state.unreadNotifications
          ? state.unreadNotifications.filter(
              (n) => n.id !== action.notification.id
            )
          : [],
        unreadCount: action.unread > 0 ? action.unread - 1 : 0,
        loading: false,
      };
    case NOTIFICATIONS_LAST:
      return {
        ...state,
      };
    case NOTIFICATIONS_LAST_SUCCESS:
      return {
        ...state,
        lastNotifications: action.lastNotifications,
      };
    default:
      return state;
  }
};

export default notifications;
